<template>
  <section class="threads-card" aria-label="Goalbook Threads">
    <div class="threads-layout">
      <img
        alt="Threads logo"
        src="@/assets/Threads_1.svg"
        class="threads-logo__img"
      >
      <p class="threads-description">Draft research-based, individualized plans from start to finish using AI.</p>
      <ul class="threads-buttons" role="list">
        <li
          v-for="thread in threads"
          :key="thread.key"
          class="threads-buttons__item"
        >
          <div class="thread-button-container">
            <BetaBadge v-if="thread.beta" class="thread-button__badge" />
            <a
              :href="thread.href"
              class="thread-button"
              :aria-label="thread.beta ? thread.label + ' (Beta)' : thread.label"
            >
              <span class="thread-button__label">{{ thread.label }}</span>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { threadsUrls } from '@/links'
import BetaBadge from '../BetaBadge.vue';

const ALL_THREADS = [
  {
    key: 'annual-iep',
    label: 'Annual IEP',
    href: threadsUrls.annualIEP,
  },
  {
    key: 'bsp',
    label: 'Behavior Support Plan',
    href: threadsUrls.bsp,
    beta: true,
  },
]

const FULLY_RELEASED_THREADS = ['annual-iep', 'bsp']

export default {
  name: 'ThreadsCardLink',
  components: {
    BetaBadge,
  },
  props: {
    betaMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    threads() {
      return ALL_THREADS.filter((thread) => {
        if (FULLY_RELEASED_THREADS.includes(thread.key)) return true
        return this.betaMode
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/variables.less';

.threads-card {
  border: 2px solid @border-light-gray;
  padding: 20px;
}

.threads-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.threads-logo__img {
  height: 30px;
  width: auto;
}

.threads-description {
  margin: 0;
  color: @gray-dark;
}

.threads-buttons {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;

  &__item {
    margin: 0;
    padding-top: 8px;
  }
}

.thread-button-container {
  position: relative;
}

.thread-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  padding: 16px 24px;
  border: 1px solid @link-darker;
  border-radius: 8px;
  text-decoration: none;
  color: @link-darker;
  font-size: 16px;
  font-weight: @font-weight-600;
  text-align: center;

  &:hover {
    background: @gray-lighter;
  }

  &:focus-visible {
    outline: 2px solid @link-darker;
    outline-offset: 2px;
  }

  &__badge {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
